import Admin__Cms__SnippetsController from './snippets.js'

Skylark.App.Controllers.register({
  Admin__Cms__SnippetsController
})

export default Admin__Cms__SnippetsController
